import { ReferenceCrud } from "@/components/admin/ReferenceCrud";
import { StatusBadge } from "@/components/admin/AdminUI";
import { titleCase } from "@/lib/format";

const FIELDS = [
  { name: "name", label: "Collection name", required: true, max: 120 },
  { name: "slug", label: "Slug", hint: "Leave empty to generate from the name", max: 120 },
  { name: "gender", label: "Audience", type: "select", default: "all", options: [{ value: "all", label: "Everyone" }, { value: "women", label: "Women" }, { value: "men", label: "Men" }, { value: "kids", label: "Kids" }] },
  { name: "display_order", label: "Display order", type: "number", default: 0, min: 0 },
  { name: "hero_image_url", label: "Hero image URL", type: "url", optional: true, nullable: true, span: 2, placeholder: "https://…", max: 1000 },
  { name: "description", label: "Editorial description", type: "textarea", rows: 4, span: 2, max: 4000 },
  { name: "seo_title", label: "SEO title", max: 70 },
  { name: "seo_description", label: "SEO description", max: 170 },
  { name: "featured", label: "Featured on homepage", type: "switch" },
];

const COLUMNS = [
  { key: "name", label: "Collection" },
  { key: "gender", label: "Audience", render: (c) => (c.gender === "all" ? "Everyone" : titleCase(c.gender)) },
  { key: "slug", label: "Slug", render: (c) => <span className="text-muted-foreground font-mono text-xs">{c.slug}</span> },
  { key: "product_count", label: "Products", className: "text-right tabular", render: (c) => c.product_count ?? 0 },
  { key: "featured", label: "Featured", render: (c) => (c.featured ? <StatusBadge status="good" label="Featured" tone="good" /> : <span className="text-muted-foreground">—</span>) },
];

export default function AdminCollections() {
  return <ReferenceCrud resource="collections" label="Collection" eyebrow="Catalog" description="Curated edits and seasonal stories. Products can belong to several collections." fields={FIELDS} columns={COLUMNS} writePerm="catalog.write" searchPlaceholder="Search collections…" />;
}
